import { render } from "./EditPreferencesThird.vue?vue&type=template&id=67ce7b76&scoped=true"
import script from "./EditPreferencesThird.vue?vue&type=script&lang=js"
export * from "./EditPreferencesThird.vue?vue&type=script&lang=js"

import "./EditPreferencesThird.vue?vue&type=style&index=0&id=67ce7b76&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce7b76"]])

export default __exports__